/**
 * This component is used to only show 'check your email'.  It gets redirected to immediately after reseller signup.  
 * The only purpose is so we can track analytics differently from the home page.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Grid, Paper, Table, TableBody, TableContainer, TableCell, TableRow, Typography
} from '@mui/material';

import AbEnvironment from '../auth/AbEnvironment';

import Email from '@mui/icons-material/Email';
import AssentDialog from './AssentDialog';

const abEnvironment = new AbEnvironment();
const styleSheet = theme => ({
  root: {
    //marginLeft: -210,
    flexGrow: 1,
    padding: 20,
    position: 'absolute',
    top: '50px',
    left: '0px',
    width: 'calc(100% - 40px)',
  },
  flex: {
    flex: 1,
  },
  descriptiveText: {
    textAlign: 'left',
  },
  paper: {
    marginTop: 32,
    paddingTop: 16,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 20
  },
  emailIcon: {
    width: 30,
    height: 30,
  },
  logoContainer: {
    display: 'flex',
    height: '50px',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 12,
  },
  tableContainer: {
    boxShadow: "none"
  },
  powerByCell: {
    padding: 0,
    borderBottom: "none"
  }
});

class Welcome extends Component {
  state = {
    dialogOpen:  this.showAssentDialog()
  }

  needEmailVerification() {
    if (abEnvironment.getUserAttribute('email_verified') !== 'true') {
      return true;
    }
    return false;
  }

  showAssentDialog() {
    const { isAuthenticated } = this.props.auth;
    if (isAuthenticated() && (this.needAssent() || this.needEmailVerification())) {
      return true;
    }
    return false;
  }

  showAccountConfirm() {
    let uacd = abEnvironment.getUserAttribute('a_accountCDate');
    if (uacd == null || uacd === '')
      return true;

    return false;
  }
  showUserConfirm() {
    /* */
    let uucd = abEnvironment.getUserAttribute('u_userCDate');
    if (uucd == null || uucd === '')
      return true;

    return false;
    /* */
    //return true;
  }
  showTermsConfirm() {
    let utd = abEnvironment.getUserAttribute('u_termsDate');
    if (utd == null || utd === '')
      return true;

    return false;
  }

  onlyNeedTerms() {
    if (this.showTermsConfirm() && ! this.showAccountConfirm() && ! this.showUserConfirm()) {
      return true;
    }
    return false;
  }

  needAssent() {
    if (this.showAccountConfirm() || this.showUserConfirm() || this.showTermsConfirm()) {
      return true;
    }
    return false;
  }

  needAssentOrVerification() {
 
    if (this.needAssent() || this.needEmailVerification()) {
      return true;
    }
    return false;
  }


  render() {
    const { isAuthenticated } = this.props.auth;
    const classes = this.props.classes;

    if (isAuthenticated()) {
      if (this.needAssentOrVerification())
      {
        let assentTitle = "Let's get started";
        let titleBlock = "AssentAndEmailConfirm";
        
        if (!this.needAssent() && this.needEmailVerification()) {
          assentTitle = "Welcome! Let's get started.";
          titleBlock = "EmailConfirm";
        }

        return (
          <AssentDialog
            title={assentTitle}
            open={this.state.dialogOpen}
          >
            <Grid container spacing={2} direction="row" justifyContent="flex-start">
  
              { titleBlock === 'EmailConfirm'  &&
              <React.Fragment>
                  <Grid container spacing={0} align="center" justifyContent="center" alignItems="center">
                     <Paper style={{border:'solid #eee 8px', background:'#f8f8f8'}} className={classes.paper} elevation={1} >
                     
                      <Grid item style={{padding:'32px'}}>
                    
                        <Email style={{width:'64px', height:'64px', color:'#7d54ea'}} htmlColor={'primary'} className={classes.emailIcon} />
                              
                        
                        <Typography variant="h5" >
                          <strong>Verify your email</strong>
                        </Typography>
                        <Typography variant="h6" style={{marginTop: '16px'}}>
                          Look for an email from <strong style={{color: '#7d54ea'}}>AppBind</strong>.<br></br>Click the button!
                        </Typography>
                      </Grid>
                    </Paper>
                  </Grid>

                  <Grid container spacing={0} align="center" justifyContent="center" alignItems="center">
                    <Grid item style={{marginTop: '16px'}}>
                      <TableContainer className={classes.tableContainer} >
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell className={classes.powerByCell}><Typography variant="caption">Powered by</Typography></TableCell>
                            <TableCell  className={classes.powerByCell}>
                                <div className={classes.logoContainer}>
                                  <img alt="AppBind Logo" height="30px" src={'https://app.appbind.com/logos/appbind-logo-c-b.png'} />
                                </div>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>
              </React.Fragment>

              }

              { titleBlock === 'AssentAndEmailConfirm' && this.needEmailVerification() &&
              <Grid item xs={12}>
                <Typography variant="body1" className={classes.descriptiveText}>
                  After confirming, please check your email for a welcome email from AppBind.  
                  This email contains a link to verify your email address and activate
                  your new AppBind account.
                </Typography>
              </Grid>
              }
            </Grid>
          </AssentDialog>
        );
      } 
    } else {
      return (
        <div></div>
      );
    }
  }
}

Welcome.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(Welcome);
